var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"h-100"},[_c('v-chart',{ref:"chart",attrs:{"options":_vm.options,"init":_vm.chartInit,"ready":_vm.chartReady},on:{"contextmenu":_vm.contextmenu}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }